<template>
  <div class="customer-basic-pane">
    <map-drag
      :lat.sync="lat"
      :lng.sync="lng"
      :mapVisible.sync="mapVisible"
      :type="showType"
      @getLocation="getLocation"
    ></map-drag>
    <a-card
      :body-style="{ padding: '0px' }"
      :bordered="false"
      class="detail-content-card"
    >
      <a-form-model
        ref="form"
        :labelCol="{ span: 6 }"
        :model="currentCustomerInfo"
        :rules="customerInfoRules"
        :wrapperCol="{ span: 18 }"
        class="disabled-form customer-detail-form"
        labelAlign="right"
        @submit.native.prevent
      >
        <a-row class="detail-section-title">
          <a-col :lg="24" :md="24" :sm="24" :xl="24" :xs="24" :xxl="24">
            <div
              style="display: flex;justify-content: flex-start;vertical-align: middle;align-items: center"
            >
              <h3 style="color: #0b64f4;">客户基本信息</h3>
            </div>
          </a-col>
        </a-row>
        <a-row class="detail-section-title">
          <a-col :lg="8" :md="24" :sm="24" :xl="8" :xs="24" :xxl="8">
            <a-form-model-item label="客户名称" prop="customerName">
              <el-autocomplete
                v-model="currentCustomerInfo.customerName"
                :disabled="disableFormItem()"
                :fetch-suggestions="changeFilterCustomerName"
                :trigger-on-focus="false"
                placeholder="请输入客户名称"
                style="width: 100%"
              ></el-autocomplete>
            </a-form-model-item>
          </a-col>
          <a-col :lg="8" :md="24" :sm="24" :xl="8" :xs="24" :xxl="8">
            <a-form-model-item label="搜索词" prop="searchWord">
              <a-input
                v-model="currentCustomerInfo.searchWord"
                placeholder="客户搜索词"
                :disabled="disableFormItem()"
                @change="searchWordChange"
              />
            </a-form-model-item>
          </a-col>
          <a-col :lg="8" :md="24" :sm="24" :xl="8" :xs="24" :xxl="8">
            <a-form-model-item label="关键词" prop="keywordID">
              <a-input
                v-model="currentCustomerInfo.keyword"
                placeholder="客户来源关键字"
                :disabled="disableFormItem()"
                @change="keywordChange"
              />
            </a-form-model-item>
          </a-col>

          <a-col :lg="8" :md="24" :sm="24" :xl="8" :xs="24" :xxl="8">
            <a-form-model-item label="客户区域" prop="customerRegionType">
              <a-select
                v-model="currentCustomerInfo.customerRegionType"
                :disabled="disableFormItem()"
                placeholder="请选择国内或国外"
                @change="onCustomerRegionTypeChange"
              >
                <a-select-option :value="1">国内</a-select-option>
                <a-select-option :value="2">国外</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :lg="8" :md="24" :sm="24" :xl="8" :xs="24" :xxl="8">
            <a-form-model-item label="国家或地区" prop="country">
              <a-input
                v-if="isDomesticCustomer"
                v-model="currentCustomerInfo.country"
                disabled
                placeholder="国家或地区"
              />
              <a-select
                v-else
                v-model="currentCustomerInfo.country"
                :disabled="disableFormItem()"
                :filterOption="filterCountry"
                allowClear
                placeholder="请选择国家或地区"
                show-search
                @change="onCountryChange"
              >
                <a-select-option
                  v-for="item in allCountryMap"
                  :key="item.key"
                  :value="item.key"
                >
                  {{ item.key }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col
            v-if="!isDomesticCustomer"
            :lg="8"
            :md="24"
            :sm="24"
            :xl="8"
            :xs="24"
            :xxl="8"
          >
            <a-form-model-item label="所属大洲" prop="continent">
              <a-input
                v-model="currentCustomerInfo.continent"
                disabled
                placeholder="选择国家后自动带出"
              />
            </a-form-model-item>
          </a-col>

          <a-col :lg="8" :md="24" :sm="24" :xl="8" :xs="24" :xxl="8">
            <a-form-model-item label="来源平台" prop="sourcePlatformName">
              <a-auto-complete
                v-model="currentCustomerInfo.sourcePlatformName"
                :data-source="sourcePlatformNames"
                :disabled="disableFormItem()"
                placeholder="选择或直接输入来源平台"
                @change="sourcePlatformChange"
              />
            </a-form-model-item>
          </a-col>
          <a-col :lg="8" :md="24" :sm="24" :xl="8" :xs="24" :xxl="8">
            <a-form-model-item label="客户状态" prop="tag">
              <a-select
                v-model="currentCustomerInfo.tag"
                :allowClear="true"
                :disabled="disableFormItem()"
                :filterOption="filterCategory"
                :not-found-content="null"
                :show-arrow="false"
                placeholder="输入客户状态"
                show-search
              >
                <a-select-option
                  v-for="item in allCustomerTagMap"
                  :key="Number(item.key)"
                  :value="Number(item.key)"
                  >{{ item.value }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :lg="8" :md="24" :sm="24" :xl="8" :xs="24" :xxl="8">
            <a-form-model-item label="客户分类" prop="customerType">
              <a-select
                v-model="currentCustomerInfo.customerType"
                :allowClear="true"
                :disabled="disableFormItem()"
                :not-found-content="null"
                :show-arrow="false"
                placeholder="选择客户分类"
                show-search
              >
                <a-select-option
                  v-for="item in customerType"
                  :key="item.key"
                  :value="item.value"
                  >{{ item.key }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :lg="8" :md="24" :sm="24" :xl="8" :xs="24" :xxl="8">
            <a-form-model-item label="所属行业" prop="business">
              <a-select
                v-model="currentCustomerInfo.business"
                :allowClear="true"
                :disabled="disableFormItem()"
                :filterOption="filterCategory"
                :not-found-content="null"
                :show-arrow="false"
                placeholder="输入客户所属行业"
                show-search
              >
                <a-select-option
                  v-for="item in allCustomerBusinessMap"
                  :key="Number(item.key)"
                  :value="Number(item.key)"
                  >{{ item.value }}
                </a-select-option>
                <a-select-option :key="0" :value="0">- </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>

          <!-- <a-col :lg="8" :md="24" :sm="24" :xl="8" :xs="24" :xxl="8"></a-col> -->
          <a-col :lg="8" :md="24" :sm="24" :xl="8" :xs="24" :xxl="8">
            <a-form-model-item label="客户性质" prop="nature">
              <a-select
                v-model="currentCustomerInfo.nature"
                :allowClear="true"
                :disabled="disableFormItem()"
                :filterOption="filterCategory"
                :not-found-content="null"
                :show-arrow="false"
                placeholder="输入客户公司性质"
                show-search
              >
                <a-select-option
                  v-for="item in allCustomerNatureMap"
                  :key="Number(item.key)"
                  :value="Number(item.key)"
                  >{{ item.value }}
                </a-select-option>
                <a-select-option :key="0" :value="0">- </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :lg="8" :md="24" :sm="24" :xl="8" :xs="24" :xxl="8">
            <a-form-model-item label="访问方式" prop="accessType">
              <a-select
                v-model="currentCustomerInfo.accessType"
                :allowClear="true"
                :disabled="disableFormItem()"
                :filterOption="filterCategory"
                :not-found-content="null"
                :show-arrow="false"
                placeholder="选择客户访问方式"
                show-search
              >
                <a-select-option
                  v-for="item in allCustomerAccessTypeMap"
                  :key="Number(item.key)"
                  :value="Number(item.key)"
                  >{{ item.value }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :lg="24" :md="24" :sm="24" :xl="24" :xs="24" :xxl="24">
            <div
              style="display: flex;justify-content: flex-start;vertical-align: middle;align-items: center"
            >
              <h3 style="color: #0b64f4;">客户地址信息</h3>
            </div>
          </a-col>
        </a-row>
        <a-row :gutter="10">
          <a-col :lg="4" :md="24" :sm="24" :xl="4" :xs="24" :xxl="4">
            <a-form-model-item label="省" prop="province">
              <a-select
                v-if="isDomesticCustomer"
                v-model="currentCustomerInfo.province"
                :allowClear="true"
                :disabled="disableFormItem()"
                :filterOption="filterCategory"
                :not-found-content="null"
                :show-arrow="false"
                placeholder="请输入省名称"
                show-search
                @change="onProvinceChange"
              >
                <a-select-option
                  v-for="item in allProvinceList"
                  :key="item.id"
                  :value="item.name"
                  >{{ item.name }}
                </a-select-option>
              </a-select>
              <a-input
                v-else
                v-model="currentCustomerInfo.province"
                :disabled="disableFormItem()"
                placeholder="请输入州、省或一级行政区"
              />
            </a-form-model-item>
          </a-col>
          <a-col :lg="4" :md="24" :sm="24" :xl="4" :xs="24" :xxl="4">
            <a-form-model-item label="市" prop="city">
              <a-select
                v-if="isDomesticCustomer"
                v-model="currentCustomerInfo.city"
                :allowClear="true"
                :disabled="disableFormItem() || !currentCustomerInfo.province"
                :filterOption="filterCategory"
                :not-found-content="null"
                :show-arrow="false"
                placeholder="请输入城市名称"
                show-search
                @change="onCityChange"
              >
                <a-select-option
                  v-for="item in filteredCityList"
                  :key="item.id"
                  :value="item.name"
                  >{{ item.name }}
                </a-select-option>
              </a-select>
              <a-input
                v-else
                v-model="currentCustomerInfo.city"
                :disabled="disableFormItem()"
                placeholder="请输入城市名称"
              />
            </a-form-model-item>
          </a-col>
          <a-col :lg="4" :md="24" :sm="24" :xl="4" :xs="24" :xxl="4">
            <a-form-model-item label="区" prop="area">
              <a-select
                v-if="isDomesticCustomer"
                v-model="currentCustomerInfo.area"
                :allowClear="true"
                :disabled="disableFormItem() || !currentCustomerInfo.city"
                :filterOption="filterCategory"
                :not-found-content="null"
                :show-arrow="false"
                placeholder="请输入区名"
                show-search
              >
                <a-select-option
                  v-for="item in filteredAreaList"
                  :key="item.id"
                  :value="item.name"
                  >{{ item.name }}
                </a-select-option>
              </a-select>
              <a-input
                v-else
                v-model="currentCustomerInfo.area"
                :disabled="disableFormItem()"
                placeholder="请输入区、县或区域"
              />
            </a-form-model-item>
          </a-col>
          <a-col :lg="10" :md="24" :sm="24" :xl="10" :xs="24" :xxl="10">
            <a-form-model-item
              class="address-form-model-item"
              label="详细地址"
              prop="address"
            >
              <a-input
                v-model="currentCustomerInfo.address"
                :disabled="disableFormItem() || isDomesticCustomer"
                :placeholder="
                  isDomesticCustomer ? '请选择地图坐标' : '请输入国外详细地址'
                "
              />
            </a-form-model-item>
          </a-col>

          <a-col :lg="2" :md="24" :sm="24" :xl="2" :xs="24" :xxl="2">
            <a-button
              v-if="!disableFormItem() && isDomesticCustomer"
              type="primary"
              @click="showMap({}, 'choose')"
              >选择地址
            </a-button>
          </a-col>
        </a-row>

        <a-row>
          <template v-if="BASE_OPERATE_TYPE.ADD === operateType">
            <a-row
              :gutter="10"
              class="detail-section-title detail-section-inline"
            >
              <a-col :lg="24" :md="24" :sm="24" :xl="24" :xs="24" :xxl="24">
                <div
                  style="display: flex;justify-content: flex-start;vertical-align: middle;align-items: center"
                >
                  <h3 style="color: #0b64f4;">给客户指派员工</h3>
                </div>
              </a-col>
              <a-col :lg="9" :md="24" :sm="24" :xl="9" :xs="24" :xxl="9">
                <a-form-model-item label="指派员工" prop="userID">
                  <a-select
                    v-model="currentCustomerInfo.userID"
                    :allowClear="true"
                    :disabled="disableFormItem()"
                    :filterOption="filterCategory"
                    :not-found-content="null"
                    :show-arrow="false"
                    placeholder="指派客户给对应员工"
                    show-search
                  >
                    <a-select-option
                      v-for="item in allUserListMap"
                      :key="Number(item.userID)"
                      :value="Number(item.userID)"
                      >{{ item.displayName }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :lg="9" :md="24" :sm="24" :xl="9" :xs="24" :xxl="9">
                <a-form-model-item label="员工类型" prop="userType">
                  <a-select
                    v-model="currentCustomerInfo.userType"
                    :allowClear="true"
                    :disabled="disableFormItem()"
                    :filterOption="filterCategory"
                    :not-found-content="null"
                    :show-arrow="false"
                    placeholder="选择跟进员工类型"
                    show-search
                  >
                    <a-select-option
                      v-for="item in allCustomerUserTypeMap"
                      :key="Number(item.key)"
                      :value="Number(item.key)"
                      >{{ item.value }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
            </a-row>
          </template>
          <!--          <template-->
          <!--            v-if="-->
          <!--              [BASE_OPERATE_TYPE.ADD, BASE_OPERATE_TYPE.EDIT].includes(-->
          <!--                operateType-->
          <!--              )-->
          <!--            "-->
          <!--          >-->
          <!--            <a-row :gutter="10">-->
          <!--              <a-col :lg="24" :md="24" :sm="24" :xl="24" :xs="24" :xxl="24">-->
          <!--                <div-->
          <!--                  style="display: flex;justify-content: flex-start;vertical-align: middle;align-items: center"-->
          <!--                >-->
          <!--                  <h3 style="color: #0b64f4;">给客户指派员工</h3>-->
          <!--                </div>-->
          <!--              </a-col>-->
          <!--              <a-col :lg="9" :md="24" :sm="24" :xl="9" :xs="24" :xxl="9">-->
          <!--                <a-form-model-item label="指派员工" prop="userID">-->
          <!--                  <a-select-->
          <!--                    v-model="currentCustomerInfo.userID"-->
          <!--                    :allowClear="true"-->
          <!--                    :disabled="disableFormItem()"-->
          <!--                    :not-found-content="null"-->
          <!--                    :show-arrow="false"-->
          <!--                    placeholder="指派客户给对应员工"-->
          <!--                    show-search-->
          <!--                  >-->
          <!--                    <a-select-option-->
          <!--                      v-for="item in allUserListMap"-->
          <!--                      :key="Number(item.userID)"-->
          <!--                      :value="Number(item.userID)"-->
          <!--                      >{{ item.displayName }}-->
          <!--                    </a-select-option>-->
          <!--                  </a-select>-->
          <!--                </a-form-model-item>-->
          <!--              </a-col>-->
          <!--              <a-col :lg="9" :md="24" :sm="24" :xl="9" :xs="24" :xxl="9">-->
          <!--                <a-form-model-item label="员工类型" prop="userType">-->
          <!--                  <a-select-->
          <!--                    v-model="currentCustomerInfo.userType"-->
          <!--                    :allowClear="true"-->
          <!--                    :disabled="disableFormItem()"-->
          <!--                    :not-found-content="null"-->
          <!--                    :show-arrow="false"-->
          <!--                    placeholder="选择跟进员工类型"-->
          <!--                    show-search-->
          <!--                  >-->
          <!--                    <a-select-option-->
          <!--                      v-for="item in allCustomerUserTypeMap"-->
          <!--                      :key="Number(item.key)"-->
          <!--                      :value="Number(item.key)"-->
          <!--                      >{{ item.value }}-->
          <!--                    </a-select-option>-->
          <!--                  </a-select>-->
          <!--                </a-form-model-item>-->
          <!--              </a-col>-->
          <!--            </a-row>-->
          <!--          </template>-->
        </a-row>
        <a-row :gutter="10" class="detail-section-title detail-section-inline">
          <a-col :lg="24" :md="24" :sm="24" :xl="24" :xs="24" :xxl="24">
            <div
              style="display: flex;justify-content: flex-start;vertical-align: middle;align-items: center"
            >
              <h3 style="color: #0b64f4;">客户首次接洽</h3>
            </div>
          </a-col>
          <a-col :lg="6" :md="24" :sm="24" :xl="8" :xs="24" :xxl="6">
            <a-form-model-item label="需求评级" prop="approachRate">
              <a-rate
                v-model="currentCustomerInfo.approachRate"
                :disabled="disableFormItem()"
                allow-half
              >
              </a-rate>
            </a-form-model-item>
          </a-col>
          <a-col :lg="16" :md="24" :sm="24" :xl="16" :xs="24" :xxl="16">
            <a-form-model-item label="首次接洽记录" prop="approachNote">
              <a-textarea
                v-model="currentCustomerInfo.approachNote"
                :disabled="disableFormItem()"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
      <div class="bottom-button-area">
        <a-button
          v-if="operateType == BASE_OPERATE_TYPE.ADD"
          key="submit1"
          class="bottom-button"
          type="primary"
          @click="addCustomer"
        >
          提交
        </a-button>
      </div>
      <div class="bottom-button-area">
        <a-button
          v-if="operateType == BASE_OPERATE_TYPE.INFO"
          key="submit2"
          class="bottom-button"
          type="primary"
          @click="toEditCustomer"
        >
          编辑
        </a-button>

        <div class="edit">
          <a-button
            v-if="operateType == BASE_OPERATE_TYPE.EDIT"
            key="submit3"
            class="bottom-button1"
            @click="toCancelEditCustomer"
          >
            取消
          </a-button>

          <a-button
            v-if="operateType == BASE_OPERATE_TYPE.EDIT"
            key="submit4"
            class="bottom-button2"
            type="primary"
            @click="toSubmitEditCustomer"
          >
            提交
          </a-button>
        </div>
      </div>
    </a-card>
  </div>
</template>

<script>
import { fullTimeFilter } from "@/utils/utils"
import { BASE_OPERATE_TYPE, customerType } from "@/config"
import {
  GetAllCustomerName,
  GetAllKeyWord,
  GetAllSourcePlatform,
  GetAllUserList,
  GetDictionary
} from "@/api/public-api"
import {
  add,
  edit,
  GetCustomerDetailByCustomerID
} from "@/api/customer/customer"
import mapDrag from "@/components/MapDrag"
import { checkOperateDisable } from "@/router/permission"

export default {
  name: "CustomerInfoTabPane",
  data() {
    const that = this
    const validateCustomer = (rule, value, callback) => {
      const customerName = (value || "").trim()
      if (customerName === "") {
        callback(new Error("请输入客户名称"))
      } else if (
        that.operateType === BASE_OPERATE_TYPE.ADD &&
        that.allCustomerNames.map(item => item.value).includes(customerName)
      ) {
        callback(new Error("客户名称重复"))
      } else {
        callback()
      }
    }
    return {
      operateType: "",
      customerInfoRules: {
        customerName: [
          { required: true, validator: validateCustomer, trigger: "blur" }
        ],
        keyword: [
          {
            required: true,
            message: "请选择客户企业搜索关键字",
            trigger: "change"
          }
        ],
        sourcePlatformName: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!(that.currentCustomerInfo.sourcePlatformName || "").trim()) {
                callback(new Error("请选择或输入客户来源平台"))
              } else {
                callback()
              }
            },
            trigger: "change"
          }
        ],
        customerRegionType: [
          {
            required: true,
            message: "请选择客户区域",
            trigger: "change"
          }
        ],
        country: [
          {
            validator: (rule, value, callback) => {
              if (
                that.currentCustomerInfo.customerRegionType === 2 &&
                !(value || "").trim()
              ) {
                callback(new Error("国外客户必须选择国家或地区"))
              } else {
                callback()
              }
            },
            trigger: "change"
          }
        ],
        tag: [{ required: true, message: "请选择客户标志", trigger: "change" }],
        // business: [
        //   {
        //     required: true,
        //     message: "请选择企业客户所属行业",
        //     trigger: "change"
        //   }
        // ],
        // nature: [
        //   { required: true, message: "请选择企业客户性质", trigger: "change" }
        // ],
        accessType: [
          {
            required: true,
            message: "请选择企业客户访问方式",
            trigger: "change"
          }
        ],
        province: [
          {
            validator: (rule, value, callback) => {
              if (
                that.currentCustomerInfo.customerRegionType !== 2 &&
                !(value || "").trim()
              ) {
                callback(new Error("国内客户必须选择所属省"))
              } else {
                callback()
              }
            },
            trigger: "change"
          }
        ],
        customerType: [
          {
            required: true,
            message: "请选择客户分类",
            trigger: "change"
          }
        ],
        approachRate: [
          {
            required: false,
            message: "评估客户企业需求评级",
            trigger: "change"
          }
        ],
        approachNote: [
          { required: true, message: "首次接洽客户记录", trigger: "change" }
        ]
      },
      allCustomerNames: [],
      allUserListMap: [],
      allCustomerUserTypeMap: [],
      allProvinceList: require("@/config/province.json"),
      allCityData: require("@/config/city.json"),
      allCountyData: require("@/config/county.json"),
      BASE_OPERATE_TYPE,
      allKeywordMap: [],
      allSourcePlatformMap: [],
      allCustomerBusinessMap: [],
      allCustomerNatureMap: [],
      allCustomerAccessTypeMap: [],
      allCustomerTagMap: [],
      allCountryMap: [],
      currentCustomerInfo: {},
      currentCustomerID: 0,
      mapVisible: false,
      lng: "",
      lat: "",
      showType: "info",
      customerType
    }
  },
  props: {},
  computed: {
    isDomesticCustomer() {
      return this.currentCustomerInfo.customerRegionType !== 2
    },
    sourcePlatformNames() {
      return this.allSourcePlatformMap.map(item => item.platformName)
    },
    filteredCityList() {
      const provinceName = this.currentCustomerInfo.province
      if (!provinceName) {
        return []
      }
      const province = this.allProvinceList.find(
        item => item.name === provinceName
      )
      if (!province) {
        return []
      }
      return this.allCityData.filter(item => item.parent_id === province.id)
    },
    filteredAreaList() {
      const cityName = this.currentCustomerInfo.city
      if (!cityName) {
        return []
      }
      const city = this.filteredCityList.find(item => item.name === cityName)
      if (!city) {
        return []
      }
      return this.allCountyData.filter(item => item.parent_id === city.id)
    }
  },
  watch: {
    currentCustomerInfo: {
      handler() {
        if (
          !this.currentCustomerInfo.sourcePlatformName &&
          this.currentCustomerInfo.platformNameValue
        ) {
          this.$set(
            this.currentCustomerInfo,
            "sourcePlatformName",
            this.currentCustomerInfo.platformNameValue
          )
        }
      },
      deep: true
    }
  },
  components: { mapDrag },
  async created() {
    const [
      getAllUserListRes,
      allCustomerNameRes,
      allKeywordRes,
      allSourcePlatformRes,
      getCustomerUserTypeRes,
      getAllCustomerBusinessRes,
      getAllCustomerNatureRes,
      getAllCustomerAccessTypeRes,
      getCustomerTagRes,
      getCountryRes
    ] = await Promise.all([
      GetAllUserList(),
      GetAllCustomerName(),
      GetAllKeyWord(),
      GetAllSourcePlatform(),
      GetDictionary({ typeName: "customerUserType" }),
      GetDictionary({ typeName: "customerBusiness" }),
      GetDictionary({ typeName: "customerNature" }),
      GetDictionary({ typeName: "customerAccessType" }),
      GetDictionary({ typeName: "customerTag" }),
      GetDictionary({ typeName: "customerCountryContinent" })
    ])

    if (getAllUserListRes.code === 0) {
      this.allUserListMap = [
        { userID: 0, displayName: "暂不指定" },
        ...getAllUserListRes.result
      ]
    }

    if (getCustomerUserTypeRes.code === 0) {
      this.allCustomerUserTypeMap = [
        { key: 0, value: "无" },
        ...getCustomerUserTypeRes.result
      ]
    }

    if (allCustomerNameRes.code === 0) {
      this.allCustomerNames = [
        ...allCustomerNameRes.result.map(item => ({ value: item }))
      ]
    }

    if (allKeywordRes.code === 0) {
      this.allKeywordMap = allKeywordRes.result
    }
    if (allSourcePlatformRes.code === 0) {
      this.allSourcePlatformMap = allSourcePlatformRes.result
    }
    if (getAllCustomerBusinessRes.code === 0) {
      this.allCustomerBusinessMap = getAllCustomerBusinessRes.result
    }
    if (getAllCustomerNatureRes.code === 0) {
      this.allCustomerNatureMap = getAllCustomerNatureRes.result
    }
    if (getAllCustomerAccessTypeRes.code === 0) {
      this.allCustomerAccessTypeMap = getAllCustomerAccessTypeRes.result
    }
    if (getCustomerTagRes.code === 0) {
      this.allCustomerTagMap = getCustomerTagRes.result
    }
    if (getCountryRes.code === 0) {
      this.allCountryMap = [...getCountryRes.result].sort((left, right) =>
        left.key.localeCompare(right.key, "zh-CN")
      )
    }
  },
  methods: {
    keywordChange(e) {
      const keyword = e.target.value
      const result = this.allKeywordMap.find(item => {
        return item.value === keyword
      })
      if (result) {
        this.currentCustomerInfo.keywordID = result.keywordID
        this.currentCustomerInfo.keyword = result.value
        this.currentCustomerInfo.keywordValue = result.value
      } else {
        this.currentCustomerInfo.keywordID = 0
        this.currentCustomerInfo.keyword = keyword
        this.currentCustomerInfo.keywordValue = keyword
      }
    },
    searchWordChange() {
      if (!this.currentCustomerInfo.searchWordId) {
        this.currentCustomerInfo.searchWordId = 0
      }
    },
    handleSearch(value) {
      this.handleChange(value)
    },
    handleChange(value) {
      //判断value不等于null并且不为空的情况,然后把选择或者输入的值赋值,如果为空赋值为空数组
      this.value = value != null && value != "" ? value : []
      console.log(this.value)
    },
    filterTime: timeStr => fullTimeFilter(timeStr),
    filterCategory: function(value, option) {
      return option.componentOptions.children[0].text.indexOf(value) >= 0
    },
    filterCountry(value, option) {
      const country = option.componentOptions.children[0].text || ""
      return country.toLowerCase().includes((value || "").toLowerCase())
    },
    onProvinceChange() {
      this.$set(this.currentCustomerInfo, "city", undefined)
      this.$set(this.currentCustomerInfo, "area", undefined)
    },
    onCityChange() {
      this.$set(this.currentCustomerInfo, "area", undefined)
    },
    onCustomerRegionTypeChange(value) {
      if (value === 1) {
        this.$set(this.currentCustomerInfo, "country", "中国")
        this.$set(this.currentCustomerInfo, "continent", "亚洲")
      } else {
        this.$set(this.currentCustomerInfo, "country", "")
        this.$set(this.currentCustomerInfo, "continent", "")
        this.$set(this.currentCustomerInfo, "province", "")
        this.$set(this.currentCustomerInfo, "city", "")
        this.$set(this.currentCustomerInfo, "area", "")
        this.$set(this.currentCustomerInfo, "address", "")
        this.$set(this.currentCustomerInfo, "longitude", 0)
        this.$set(this.currentCustomerInfo, "latitude", 0)
      }
      this.$nextTick(() => {
        this.$refs.form.clearValidate(["customerName", "country", "province"])
      })
    },
    onCountryChange(country) {
      const countryItem = this.allCountryMap.find(item => item.key === country)
      this.$set(
        this.currentCustomerInfo,
        "continent",
        countryItem ? countryItem.value : ""
      )
    },
    sourcePlatformChange(value) {
      const sourcePlatform = this.allSourcePlatformMap.find(
        item => item.platformName === value
      )
      this.$set(
        this.currentCustomerInfo,
        "sourcePlatformID",
        sourcePlatform ? sourcePlatform.sourcePlatformID : 0
      )
    },
    checkOperateDisable,
    changeFilterCustomerName(input, cb) {
      const that = this

      const result = [...that.allCustomerNames].filter(
        item =>
          input === "" || item.value.toUpperCase().includes(input.toUpperCase())
      )
      cb(result)
    },
    disableFormItem() {
      const that = this
      return that.operateType == BASE_OPERATE_TYPE.INFO
    },
    async showData(customerID, operateType = BASE_OPERATE_TYPE.INFO) {
      const that = this
      if (that.operateType !== BASE_OPERATE_TYPE.EDIT) {
        that.operateType = operateType
        if (BASE_OPERATE_TYPE.INFO === operateType && customerID) {
          const customerDetailRes = await GetCustomerDetailByCustomerID(
            customerID
          )
          if (customerDetailRes.code === 0) {
            that.currentCustomerInfo = { ...customerDetailRes.result }
            that.$set(
              that.currentCustomerInfo,
              "keyword",
              that.currentCustomerInfo.keywordValue || ""
            )
            if (!that.currentCustomerInfo.customerRegionType) {
              that.$set(that.currentCustomerInfo, "customerRegionType", 1)
            }
            if (!that.currentCustomerInfo.country) {
              that.$set(that.currentCustomerInfo, "country", "中国")
            }
            if (!that.currentCustomerInfo.continent) {
              if (that.currentCustomerInfo.customerRegionType === 2) {
                that.onCountryChange(that.currentCustomerInfo.country)
              } else {
                that.$set(that.currentCustomerInfo, "continent", "亚洲")
              }
            }
            that.$set(
              that.currentCustomerInfo,
              "sourcePlatformName",
              that.currentCustomerInfo.platformNameValue || ""
            )
            console.log(that.currentCustomerInfo, 1238194)
            that.currentCustomerID = customerID
            that.$emit("update-customer-info", { ...customerDetailRes.result })
          }
        } else if (BASE_OPERATE_TYPE.ADD == operateType) {
          that.currentCustomerInfo = {
            customerRegionType: 1,
            country: "中国",
            continent: "亚洲"
          }
          that.$parent.currentCustomerInfo = {
            customerRegionType: 1,
            country: "中国",
            continent: "亚洲"
          }
          that.currentCustomerID = 0
        }
      }
    },

    async addCustomer() {
      const that = this
      that.$refs["form"].validate(async valid => {
        if (!valid) {
          return
        }
        const addRes = await add(this.currentCustomerInfo)
        if (addRes.code === 12 && addRes.result.customerID) {
          that.currentCustomerInfo.customerID = addRes.result.customerID
          that.$emit("update-customer-info", { ...that.currentCustomerInfo })
          that.$emit("update-customer-operate-type", BASE_OPERATE_TYPE.INFO)
          that.operateType = BASE_OPERATE_TYPE.INFO
          that.$forceUpdate()

          if (checkOperateDisable("查看客户详情")) {
            that.$emit("close-drawer")
          }
        }
      })
    },
    toSubmitEditCustomer() {
      const that = this
      that.$refs["form"].validate(async valid => {
        if (!valid) {
          return
        }
        console.log({ ...that.currentCustomerInfo })
        const updateRes = await edit({ ...that.currentCustomerInfo })
        if (updateRes.code === 14) {
          that.operateType = BASE_OPERATE_TYPE.INFO
          that.showData(that.currentCustomerID)
          that.$emit("update-customer-info", { ...that.currentCustomerInfo })
          that.$emit("update-customer-operate-type", BASE_OPERATE_TYPE.INFO)
        } else {
          that.$message.error("更新数据失败")
        }
      })
    },
    toEditCustomer() {
      this.operateType = BASE_OPERATE_TYPE.EDIT
    },
    toCancelEditCustomer() {
      this.operateType = BASE_OPERATE_TYPE.INFO
      this.showData(this.currentCustomerID)
      this.$emit("update-customer-operate-type", BASE_OPERATE_TYPE.INFO)
    },

    onCloseCustomerModal() {
      this.$refs["form"].clearValidate()
      this.operateType = ""
      this.currentCustomerID = 0
      this.currentCustomerInfo = {}
    },
    getLocation(res) {
      if (this.showType !== "info") {
        if (res.status === "confirm") {
          this.currentCustomerInfo.longitude = res.data.lng
          this.currentCustomerInfo.latitude = res.data.lat
          this.currentCustomerInfo.address = res.data.address
          this.currentCustomerInfo.province = res.data.position.provinceName
          this.currentCustomerInfo.city = res.data.position.cityName
          this.currentCustomerInfo.area = res.data.position.areaName
          this.$forceUpdate()
        }
      }
    },
    showMap(it, type = "info") {
      if (type === "info") {
        this.lat = String(it.latitude)
        this.lng = String(it.longitude)
      }
      this.mapVisible = true
      this.showType = type
    }
  }
}
</script>

<style lang="scss" scoped>
.ant-table-striped ::v-deep .table-striped td {
  background-color: #fcfcfc;
}

.customer-basic-pane {
  .detail-content-card {
    overflow: visible;
    background: transparent;
    border: 0;
    box-shadow: none;
  }

  .customer-detail-form {
    min-height: 0;
    padding: 2px 0 96px;

    > .ant-row {
      margin-bottom: 14px;
      padding: 4px 18px 8px;
      background: #fff;
      border: 1px solid #e4eaf2;
      border-radius: 12px;
      box-shadow: 0 3px 12px rgba(28, 45, 70, 0.04);
    }

    > .ant-row:empty {
      display: none;
    }

    // Section title rows are kept separate in the legacy template. These rules
    // visually connect them to the data block that follows.
    > .detail-section-title {
      margin-bottom: -15px;
      padding: 18px 20px 22px;
      border-bottom: 0;
      border-radius: 12px 12px 0 0;
      box-shadow: 0 3px 12px rgba(28, 45, 70, 0.04);
      position: relative;
      z-index: 1;

      + .ant-row {
        padding-top: 20px;
        border-top: 0;
        border-radius: 0 0 12px 12px;
      }
    }

    .detail-section-inline {
      margin-bottom: 14px;
      padding-bottom: 8px;
      border-bottom: 1px solid #e4eaf2;
      border-radius: 12px;

      + .ant-row {
        padding-top: 4px;
        border-top: 1px solid #e4eaf2;
        border-radius: 12px;
      }

      h3 {
        margin-bottom: 12px !important;
      }
    }

    h3 {
      position: relative;
      margin: 0 !important;
      padding-left: 13px;
      color: #1d2b41 !important;
      font-size: 15px;
      font-weight: 650;
      line-height: 22px;

      &::before {
        position: absolute;
        top: 4px;
        bottom: 4px;
        left: 0;
        width: 3px;
        content: "";
        background: linear-gradient(180deg, #1677ff, #54a8ff);
        border-radius: 3px;
      }
    }

    ::v-deep .ant-form-item {
      margin-bottom: 14px;
    }

    ::v-deep .ant-form-item-label {
      padding-right: 10px;

      > label {
        color: #718096;
        font-size: 12px;
        font-weight: 500;
      }
    }

    ::v-deep .ant-form-item-control {
      color: #1e293b;
      font-size: 13px;
      font-weight: 500;
    }

    ::v-deep .ant-input[disabled],
    ::v-deep .ant-select-disabled .ant-select-selection,
    ::v-deep .el-input.is-disabled .el-input__inner,
    ::v-deep .ant-input-disabled {
      min-height: 32px;
      padding-right: 10px;
      padding-left: 10px;
      color: #26364d;
      background: #f7f9fc;
      border: 1px solid #edf1f6;
      border-radius: 7px !important;
      cursor: default;
    }

    ::v-deep textarea.ant-input[disabled] {
      min-height: 64px;
      padding-top: 8px;
      line-height: 1.65;
    }

    ::v-deep .ant-rate {
      line-height: 32px;
    }
  }
}

.bottom-button-area {
  position: sticky;
  z-index: 5;
  bottom: -28px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 68px;
  margin: 0 -22px;
  padding: 14px 24px;
  background: rgba(255, 255, 255, 0.94);
  border-top: 1px solid #e5eaf2;
  box-shadow: 0 -8px 24px rgba(28, 45, 70, 0.07);
  backdrop-filter: blur(10px);

  .bottom-button {
    width: 160px;
    height: 36px;
    line-height: 34px;
    border-radius: 8px;
  }

  .edit {
    display: flex;
    justify-content: center;
    gap: 12px;
    width: 100%;
    height: auto;

    .bottom-button1 {
      float: none;
      width: 120px;
      height: 36px;
      line-height: 34px;
      margin: 0;
    }

    .bottom-button2 {
      float: none;
      width: 160px;
      height: 36px;
      line-height: 34px;
    }
  }
}
</style>
